@if (showLoading()) {
  <div class="oph-loading">
    <oph-loading></oph-loading>
  </div>
} @else {
  <div class="header">
    <div class="title">Projects & Challenges</div>
    <oph-new-button (buttonClick)="onNewProjectOrChallenge()" [buttonStyle]="{padding: '0rem 0.5rem'}">
      New
    </oph-new-button>
  </div>

  <div class="task-list">
    @for (challenge of challengesSummary(); track challenge._id) {
      <button class="task-cell" (click)="onChallengeClick(challenge)">
        <mat-icon svgIcon="target" class="task-icon"></mat-icon>
        <span class="task-label">{{ challenge.label }}</span>
      </button>
    }

    <button class="task-cell" (click)="onMySkedClick()">
      <mat-icon svgIcon="trello" class="task-icon trello-icon"></mat-icon>
      <span class="task-label">My Sked</span>
    </button>

    @for (project of projectsSummaryFiltered(); track project._id) {
      <button class="task-cell" (click)="onProjectClick(project)">
        <div class="project-color" [style.background-color]="project.color"></div>
        <span class="task-label">{{ project.label }}</span>
      </button>
    }
  </div>
}
